export const selectNotificationsEnabled = state =>
  state.chat.notifications.enabled
